export default __webpack_public_path__ + "static/media/charge.651afbc5.svg";